import Index from '../../pages/hjwq/online/index';
import Help from '../../pages/hjwq/online/help';
import Query from '../../pages/hjwq/online/query';
import Pc from '../../pages/hjwq/online/pc';

const base = 'online';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/help*`,
    name: `${base}-help`,
    component: Help
  },
  {
    path: `/${base}/query*`,
    name: `${base}-query`,
    component: Query
  },
  {
    path: `/${base}/pc*`,
    name: `${base}-pc`,
    component: Pc
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/hjwq/online.js